export const ToastMsgMapping = {
  default_success_one_line: {
    backgroundColour: "#F0FAE5",
    textColour: "#107F47",
    borderColour: "#7FBC96",
    msgTime: 3000,
    isDescription: false,
  },
  default_warning_one_line: {
    backgroundColour: "#FFF9F0",
    textColour: "#A36A00",
    borderColour: "#D1B278",
    msgTime: 3000,
    isDescription: false,
  },
  default_error_one_line: {
    backgroundColour: "#FDF4F4",
    textColour: "#D91734",
    borderColour: "#EB8593",
    msgTime: 3000,
    isDescription: false,
  },
  default_announcement_one_line: {
    backgroundColour: "#F1F2FF",
    textColour: "#38539A",
    borderColour: "#94A3CD",
    msgTime: 3000,
    isDescription: false,
  },
  default_informative_one_line: {
    backgroundColour: "#2C2C2C",
    textColour: "#FFFFFF",
    borderColour: "#2C2C2C",
    msgTime: 3000,
    isDescription: false,
  },
  default_success_details: {
    backgroundColour: "#F0FAE5",
    textColour: "#107F47",
    borderColour: "#7FBC96",
    msgTime: 3000,
    isDescription: true,
  },
  default_warning_details: {
    backgroundColour: "#FFF9F0",
    textColour: "#A36A00",
    borderColour: "#D1B278",
    msgTime: 3000,
    isDescription: true,
  },
  default_error_details: {
    backgroundColour: "#FDF4F4",
    textColour: "#D91734",
    borderColour: "#EB8593",
    msgTime: 3000,
    isDescription: true,
  },
  default_announcement_details: {
    backgroundColour: "#F1F2FF",
    textColour: "#38539A",
    borderColour: "#94A3CD",
    msgTime: 3000,
    isDescription: true,
  },
};
